import script from "./purchase_order.vue?vue&type=script&setup=true&lang=ts"
export * from "./purchase_order.vue?vue&type=script&setup=true&lang=ts"

import "./purchase_order.vue?vue&type=style&index=0&id=90225a48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90225a48"]])

export default __exports__